"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFactoryBindingCallback = resolveFactoryBindingCallback;
function resolveFactoryBindingCallback(params, binding) {
    return binding.factory(params.context);
}
//# sourceMappingURL=resolveFactoryBindingCallback.js.map